export enum VehiclePriceUnit {
  HOUR = 'HOUR',
  // SWIMMING_TOUR = 'SWIMMING_TOUR', analytics icin eklenecek
  DAY = 'DAY',
  HALF_DAY = 'HALF_DAY',
  WEEK = 'WEEK',
}
